import { render, staticRenderFns } from "./IndicadorRentabilidadBruta.vue?vue&type=template&id=877b547a&"
import script from "./IndicadorRentabilidadBruta.vue?vue&type=script&lang=js&"
export * from "./IndicadorRentabilidadBruta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports